import IAccessoriesCategory from '../model/accessories/IAccessoriesCategory';

const accessoryService = {
  getSelectedAccessories: (category: IAccessoriesCategory, option: string, selected: boolean) => {
    return category.accessories.map(accessory => {
      if (accessory.id === option) {
        return { ...accessory, selected };
      }

      return accessory;
    });
  },

  getSelectedCategories: (accessoriesCategories: IAccessoriesCategory[], option: string, selected: boolean) => {
    return accessoriesCategories.map(category => ({
      ...category,
      accessories: accessoryService.getSelectedAccessories(category, option, selected),
    }));
  },
};

export default accessoryService;
